import { useCallback } from 'react'
import type { TimelineElement } from '../context/TimelineContext'
import { useAuth } from '../context/useAuth'
import { useWorkspace } from '../context/useWorkspace'

const hasPrivilegedRole = (role: string) => role === 'OWNER' || role === 'ADMIN'

export const useCanvasPermissions = () => {
  const { currentUser } = useAuth()
  const { activeRole, appMode } = useWorkspace()

  const canReadElement = useCallback((element: TimelineElement | null | undefined) => {
    if (hasPrivilegedRole(activeRole)) return true
    if (appMode === 'TEAM') return Boolean(currentUser && element)
    if (!currentUser || !element) return false
    return element.readAccess.includes(currentUser.uid)
  }, [activeRole, appMode, currentUser])

  const canEditElement = useCallback((element: TimelineElement | null | undefined) => {
    if (hasPrivilegedRole(activeRole)) return true
    if (appMode === 'TEAM') return activeRole === 'EDITOR' && Boolean(currentUser && element)
    if (!currentUser || !element) return false
    return element.writeAccess.includes(currentUser.uid)
  }, [activeRole, appMode, currentUser])

  return {
    canEditElement,
    canReadElement,
  }
}
